export default "__VITE_ASSET__C6buAhQ2__"